import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import { ComposeFeedback, ComposeFeedbackViewState } from 'owa-compose-feedback';
import SmartComposeAriaLiveRegion from './SmartComposeAriaLiveRegion';
import store from '../store/store';

export default observer(function SmartComposeUI(props: PluginUIProps<ComposeFeedbackViewState>) {
    const { feedbackRibbonDetails, shouldShowFeedbackRibbon, isFeedbackProvided } = props.viewState;

    const suggestion: string = store()?.viewState?.currentlyAnnouncedSuggestion;

    return (
        <>
            <ComposeFeedback
                feedbackRibbonDetails={feedbackRibbonDetails}
                shouldShowFeedbackRibbon={shouldShowFeedbackRibbon}
                isFeedbackProvided={isFeedbackProvided}
            />
            <SmartComposeAriaLiveRegion suggestion={suggestion} />
        </>
    );
});
